import React from "react";
import AppState from './contexts/AppState';
import { LanguageProvider } from "./i18n";
import "@rainbow-me/rainbowkit/styles.css";
import { getDefaultConfig, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { WagmiProvider } from "wagmi";
import { mainnet, polygon, optimism, arbitrum, base,sepolia,bsc } from "wagmi/chains";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

const projectId = "fe62b424c4ab666f47d64744e0b3dca0";
const config = getDefaultConfig({
  appName: "faucet",
  projectId: projectId,
  chains: [arbitrum], // mainnet,sepolia,bsc, arbitrum
  ssr: true,
});

const queryClient = new QueryClient();

function Providers({ children }) {
  return (
    <AppState>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider>
            <LanguageProvider>{children}</LanguageProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </AppState>
  );
}

export default Providers;
